import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ah-assets-import-summary-modal',
    templateUrl: './assets-import-summary-modal.component.html',
    styleUrls: ['./assets-import-summary-modal.component.scss'],
    standalone: false
})
export class AssetsImportSummaryModalComponent implements OnInit {
    totalAssets
    constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<AssetsImportSummaryModalComponent>) { }

    ngOnInit(): void {
        this.totalAssets = this.data.totalAssets;
    }

}
